import { render } from "./Finish.vue?vue&type=template&id=3dfa0438&scoped=true"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"

import "./Finish.vue?vue&type=style&index=0&id=3dfa0438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfa0438"]])

export default __exports__